export default __webpack_public_path__ + "static/media/contract-length.2b6324ef.jpg";